<template>
  <div class="jobs-create" v-loading="loading" style="padding-top: 20px">
    <el-form>
      <div style="width: 100%" v-if="(!$route.params.type || $route.params.type  === 'JOB')">
      <span class="obj-name" v-if="object">
        Выбранный объект: <strong>{{ ` ` + object.name }}</strong>
      </span>
        <AddObjects
          v-if="!obj"
          :confirmDisable="true"
          :isSelect="!!object"
          @add-objects="(n) => object = n"
        />
      </div>
      <el-form-item label="Тип" class="select-type" v-if="!$route.params.type">
        <el-select v-model="form.type">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Название">
        <el-input v-model="form.name" placeholder="Название"/>
      </el-form-item>
      <div v-if="$route.params.type !=='TECH' && $route.params.type !=='PROF'">
        <el-form-item label="Проектные объемы">
          <el-input type="number" v-model="form.plan" @input="setPrice" placeholder="Проектные объемы"/>
        </el-form-item>
        <unit-select v-model="form.unit"/>
      </div>
      <div v-else-if="$route.params.type">
        <filter-select
          v-model="form.kind"
          label="Вид"
          :options="options_units[$route.params.type.toLowerCase()]"
        />
      </div>
      <div v-if="!$route.params.type || $route.params.type === 'JOB' || type_prop === 'JOB' ">
        <filter-select
          v-model="form.work_type"
          label="Вид работы"
          :options="options_works"
        />

        <!--        <el-form-item label="Вид работы">-->
        <!--          <el-select v-model="form.work_type">-->
        <!--            <el-option-->
        <!--              v-for="item in options_works"-->
        <!--              :key="item.name"-->
        <!--              :label="item.name"-->
        <!--              :value="item.id"-->
        <!--            >-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item> deadline_accounting-->
      </div>
      <div v-if="this.$store.state.project.price  && $route.params.type !=='TECH' && $route.params.type !=='PROF'">
        <el-form-item label="План стоимость">
          <el-input type="number" v-model="form.price_plan" @input="setPrice" placeholder="План стоимость"/>
        </el-form-item>
        <el-form-item label="Стоимость на ед. объема">
          <el-input type="number" v-model="form.price_unit" placeholder="Стоимость на ед. объема"/>
        </el-form-item>
      </div>
      <div
        v-if="this.$store.state.project.deadline_accounting  && $route.params.type !=='TECH' && $route.params.type !=='PROF'">
        <el-form-item label="Дата начала работы">
          <el-date-picker
            :editable="false"
            format="yyyy-MM-dd"
            @change="changeDate"
            v-model="form.start_date"
            type="date"
            placeholder="Укажите дату"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Дата окончаниия работы">
          <el-date-picker
            :editable="false"
            format="yyyy-MM-dd"
            @change="changeDate"
            v-model="form.end_date"
            type="date"
            placeholder="Укажите дату"
          >
          </el-date-picker>
        </el-form-item>
      </div>
      <div class="jobs-create__buttons">
        <el-button v-if="$route.name !== 'JobEdit'" @click="close">Отмена</el-button>
        <el-button v-else type="danger" @click="deleteObject">Удалить</el-button>

        <el-button v-if="$route.name !== 'JobEdit'" type="primary" @click="save">Сохранить</el-button>
        <el-button v-else type="primary" @click="edit">Редактировать</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import FilterSelect from '../../../components/FilterSelect';
import work_units from '../../../data/work_units';
import AddObjects from '../Reports/components/AddObjects';
import UnitSelect from '../components/unitSelect';
import {getUnits} from '../../../firestore/units';
import {fetchObjectsWithParent} from "../../../firestore/objects";
import {BigNumber} from "bignumber.js";
import dayjs from "dayjs";

export default {
  name: 'Create',
  props: {
    isNested: Boolean,
    obj: String,
    type_prop: String,
  },
  components: {UnitSelect, AddObjects, FilterSelect},
  data() {
    return {
      options_units: work_units,
      loading: false,
      checked: false,
      object: null,
      form: {
        name: '',
        plan: '',
        start_date: null,
        end_date: null,
        type: this.type_prop || this.$route.params.type || '',
        unit: '',
        unit_id: null,
        work_type: null,
        kind: null,
        price_plan: null,
        price_unit: null,
      },
      options_works: [],
      options: [
        {
          value: 'JOB',
          label: 'Работы',
        },
        {
          value: 'TECH',
          label: 'Техника',
        },
        {
          value: 'PROF',
          label: 'Профессия',
        },
      ],
    };
  },

  async mounted() {
    this.options_units = {
      ...this.options_units,
      main: await getUnits(this.$store.state.project.id),
    };

    let req = null;
    const result = [];
    const where = ((this.type_prop || this.$route.params.type) ? ((this.type_prop && this.type_prop.toLowerCase())
      || this.$route.params.type.toLowerCase()) : 'job')
    req = firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('works_type')
      .where('type', 'in', [where, where.toUpperCase()]
      );

    if (this.obj) {
      this.getObject(this.obj);
    }

    req.get()
      .then((data) => {
        data.forEach((subDoc) => {
          const data = subDoc.data();
          result.push({
            value: subDoc.id,
            label: data.name,
          });
        });
      })
      .finally(() => {
        this.options_works = [
          {
            label: 'Не выбрано',
            value: null,
          },
          ...result,
        ];
        this.loader = false;
      });

    if (this.$route.name === 'JobEdit') {
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs').doc(this.$route.params.id).get().then((data) => {

        const subData = data.data();

        const unit = this.options_units.main.find((f) => f.label === subData.unit || f.value === subData.unit_id);

        if (subData.objects[0]) {
          this.getObject(subData.objects[0]);
        }

        let work_type = this.options_works.find((e) => e.value === subData.work_type);

        if (!subData.work_type && subData.work_type_name && subData.work_type_name.length) {
          work_type = this.options_works.find((e) => e.label === subData.work_type_name);
        }


        if (!work_type) {
          work_type = null;
        }

        this.form = {
          ...this.form,
          ...subData,
          work_type,
          unit,
        };
      });
    } else {
      if (this.$route.params.id) {
        this.getObject(this.$route.params.id);
      }
    }

  },

  methods: {
    changeDate() {
      const start = dayjs(this.form.start_date).unix();
      const end = dayjs(this.form.end_date).unix();

      if (start && end && start > end) {
        this.form.start_date = null;
        this.$notify.error({title: 'Ошибка', message: 'Дата начала должна быть не позднее даты окончания'});
      }
    },
    setPrice() {
      if (this.form.plan && this.form.price_plan) {
        this.form.price_unit = (new BigNumber(this.form.price_plan).div(this.form.plan).toNumber()).toFixed(2);
      }
    },
    async getObject(id) {
      this.object = await fetchObjectsWithParent(id, this.$store.state.project.id);
    },
    deleteObject() {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('jobs')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
            this.$router.go(-1);
          });
      });
    },
    close() {
      if (!this.isNested) {
        this.$router.go(-1);
      }
      this.$emit('close');
    },

    edit() {
      let work_type = null;
      if (this.form.work_type && this.form.work_type.value) {
        work_type = this.options_works.find((opt) => opt.value === (this.form.work_type && this.form.work_type.value));
      }
      const objectID = (this.object && this.object.id);
      this.loading = true;
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs').doc(this.$route.params.id)
        .update({
          price_plan: this.form.price_plan,
          price_unit: this.form.price_unit,
          name: this.form.name,
          plan: this.form.plan,
          type: this.form.type,
          kind: this.form.kind,
          start_date: this.form.start_date ? dayjs(this.form.start_date).format('YYYY-MM-DD') : null,
          end_date: this.form.end_date ? dayjs(this.form.end_date).format('YYYY-MM-DD') : null,
          objects: [objectID || 'all'],
          unit: this.form.unit && this.form.unit.label || null,
          unit_id: this.form.unit && this.form.unit.value || null,
          work_type: (this.form.work_type && this.form.work_type.value) || '',
          work_type_name: work_type && work_type.label || '',
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Работа отредактирована',
          type: 'success',
        });
        setTimeout(() => this.$router.go(-1), 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    async save() {
      // this.loading = true;
      const objectID = (this.object && this.object.id);

      let objects = this.$route.params.id === 'new' || this.checked ? [objectID || 'all'] : [objectID || this.obj || this.$route.params.id || 'all'];

      if (this.$route.params.type === 'TECH' || this.$route.params.type === 'PROF') {
        objects = ['all'];
      }
      let work_type = this.options_works.find((opt) => opt.value === (this.form.work_type && this.form.work_type.value));

      if (!this.form.work_type || !this.form.work_type.value) {
        work_type = null;
      }

      const form = {...this.form};
      delete form.job;

      const jobs_s_r = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs')
        .orderBy("index", 'desc').limit(1)
        .get();

      let jobs_s = {
        index: 0
      };

      jobs_s_r.forEach((subDoc) => {
        jobs_s = subDoc.data();
      });

      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs')
        .add({
          ...form,
          work_type: work_type && work_type.value || null,
          work_type_name: work_type && work_type.label || '',
          start_date: this.form.start_date ? dayjs(this.form.start_date).format('YYYY-MM-DD') : null,
          end_date: this.form.end_date ? dayjs(this.form.end_date).format('YYYY-MM-DD') : null,
          unit: this.form.unit.label || null,
          unit_id: this.form.unit.value || null,
          objects,
          index: jobs_s.index + 1,
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Новая работа добавлена',
          type: 'success',
        });
        this.form = {
          name: '',
          plan: '',
          type: '',
          unit: '',
        };
        setTimeout(() => {
          if (!this.isNested) {
            this.$router.go(-1);
          }
          this.$emit('created');
        }, 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-create {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 42px auto;

  > > > .el-form-item {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }

    .el-form-item__label {
      padding: 0;
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }

  .select-type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.obj-name {
  text-align: left;
  margin-bottom: 10px;
  display: flex;
  width: 100%;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/Create.vue